import React, { useCallback } from 'react';

import {
  Create,
  email,
  ReferenceArrayInput,
  required,
  SimpleForm,
  TextInput,
  useNotify,
} from 'react-admin';
import { Box, Card, CardContent } from '@mui/material';

import errorNotification from '../../utilities/errorNotification';
import { memberCleaner } from '../../utilities/dataProvider/cleaner';
import resourceNames from '../../constants/resourceNames';

const MemberCreate = () => {
  const notify = useNotify();

  const onError = useCallback((e: unknown) => {
    notify(errorNotification(e), { type: 'error' });
  }, [notify]);

  return (
    <Create
      mutationOptions={{ onError }}
      transform={memberCleaner}
    >
      <Card variant="outlined">
        <CardContent>
          <SimpleForm component={Box}>
            <TextInput validate={required()} source="firstName" />
            <TextInput validate={required()} source="lastName" />
            <TextInput validate={[email(), required()]} source="email" />
            <ReferenceArrayInput reference={resourceNames.PERMISSION_ROLES} label="Permission Roles" source="permissionRoleIds" />
          </SimpleForm>
        </CardContent>
      </Card>
    </Create>
  );
};

export default MemberCreate;
